<template>
  <v-card>
    <div style="min-height: 4px">
      <v-progress-linear
        v-if="loading"
        indeterminate
      ></v-progress-linear>
    </div>
    <v-card-title class="align-start mb-8">
      <span class="font-weight-semibold">Total de Tickets por Status</span>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
          v-for="data in dadosTickets"
          :key="data.nome"
          cols="6"
          md="3"
          class="d-flex align-center"
        >
          <v-avatar
            size="44"
            :color="resolveStatisticsIconVariation(data.nome).color"
            rounded
            class="elevation-1"
          >
            <v-icon
              dark
              color="white"
              size="30"
            >
              {{ resolveStatisticsIconVariation(data.nome).icon }}
            </v-icon>
          </v-avatar>
          <div class="ms-3">
            <p class="text-xs mb-0">
              {{ data.nome }}
            </p>
            <h3 class="text-xl font-weight-semibold">
              {{ data.total }}
            </h3>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiAccountOutline, mdiTrendingUp, mdiAccountCheck, mdiAccountClock, mdiAccountPlus } from '@mdi/js'

export default {
  props: {
    dadosTickets: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },

  },

  data: () => ({
  }),

  methods: {
  },

  setup() {
    const resolveStatisticsIconVariation = data => {
      if (data === 'Total') return { icon: mdiTrendingUp, color: 'primary' }
      if (data === 'Novo') return { icon: mdiAccountPlus, color: 'primary' }
      if (data === 'Andamento') return { icon: mdiAccountClock, color: 'primary' }
      if (data === 'Resolvido') return { icon: mdiAccountOutline, color: 'primary' }
      if (data === 'Finalizado') return { icon: mdiAccountCheck, color: 'primary' }

      return { icon: mdiAccountOutline, color: 'success' }
    }

    return {
      resolveStatisticsIconVariation,

      // icons
      icons: {
        mdiTrendingUp,
        mdiAccountOutline,
        mdiAccountCheck,
        mdiAccountClock,
        mdiAccountPlus,
      },
    }
  },
}
</script>
